import React from 'react'

const InputKeyValue = ({ title, colSpan = 1, error, classNameData, classNameTitle, ...rest}) => {


  const tilteClass = classNameTitle !== undefined ? `g-profile__info g-profile__info--editable ${classNameTitle}` : "g-profile__info g-profile__info--editable"
  const dataClass = classNameData !== undefined ? `w-full g-profile__info g-profile__info--value outline-none ${classNameData}` : "w-full g-profile__info g-profile__info--value outline-none"

  return (
    <div colSpan={colSpan} className="g-profile__table-cell">
      <div className={tilteClass}>
        <span>{title}{error && <p className="error small-title-size lowercase">{error.join(' ')}</p>}</span>
        <i className="g-profile__info-icon far fa-edit"></i>
      </div>
      <input className={dataClass} {...rest}/>
    </div>
  )
}

export default InputKeyValue
